/*
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the MIT license.
*/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
define(["require", "exports", "azure-devops-ui/MessageCard", "azure-devops-ui/Page", "azure-devops-ui/Spinner", "azure-devops-ui/Status", "azure-devops-ui/Tabs", "azure-devops-ui/Util", "history", "react", "simple-query-string", "../../Resources", "../Common/PageTopHeader", "../Constants", "../FluxCommon/ActionsCreatorManager", "../FluxCommon/StoreManager", "../ImageDetails/ImageDetails", "../ImageDetails/ImageDetailsActionsCreator", "../KubeFactory", "../Utils", "./PodLog", "./PodOverview", "./PodsActionsCreator", "./PodsStore", "./PodYaml", "./PodsRightPanel.scss"], function (require, exports, MessageCard_1, Page_1, Spinner_1, Status_1, Tabs_1, Util_1, history_1, React, queryString, Resources, PageTopHeader_1, Constants_1, ActionsCreatorManager_1, StoreManager_1, ImageDetails_1, ImageDetailsActionsCreator_1, KubeFactory_1, Utils_1, PodLog_1, PodOverview_1, PodsActionsCreator_1, PodsStore_1, PodYaml_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var PodsRightPanel = /** @class */ (function (_super) {
        __extends(PodsRightPanel, _super);
        function PodsRightPanel(props) {
            var _this = _super.call(this, props, {}) || this;
            _this._onSelectedTabChanged = function (selectedTab) {
                var routeValues = __assign({}, queryString.parse(_this._historyService.location.search));
                routeValues["view"] = selectedTab;
                _this._historyService.replace({
                    pathname: _this._historyService.location.pathname,
                    search: queryString.stringify(routeValues)
                });
                _this.setState({
                    selectedTab: selectedTab
                });
                _this.props.notifyTabChange && _this.props.notifyTabChange();
            };
            _this._hideImageDetails = function () {
                _this.setState({
                    selectedImageDetails: undefined
                });
            };
            _this._historyService = history_1.createBrowserHistory();
            var queryParams = queryString.parse(_this._historyService.location.search);
            var selectedPivot = "pod-details" /* PodsDetailsKey */;
            // If view is present, load corresponding tab
            if (queryParams && queryParams.view) {
                selectedPivot = queryParams.view;
            }
            if (!props.pod && props.podUid) {
                // This case will only occur when opening orphaned pods
                var podsActionCreator = ActionsCreatorManager_1.ActionsCreatorManager.GetActionCreator(PodsActionsCreator_1.PodsActionsCreator);
                var podsStore_1 = StoreManager_1.StoreManager.GetStore(PodsStore_1.PodsStore);
                var onPodsFetched_1 = function () {
                    var podList = podsStore_1.getState().podsList;
                    if (podList && podList.items) {
                        var pod = podList.items.find(function (i) { return i.metadata.uid === props.podUid; });
                        if (pod) {
                            var _a = Utils_1.Utils.generatePodStatusProps(pod.status), statusProps = _a.statusProps, tooltip = _a.tooltip;
                            _this.setState({
                                pod: pod,
                                podStatusProps: statusProps,
                                statusTooltip: tooltip
                            });
                        }
                    }
                    podsStore_1.removeListener(Constants_1.PodsEvents.PodsFetchedEvent, onPodsFetched_1);
                };
                podsStore_1.addListener(Constants_1.PodsEvents.PodsFetchedEvent, onPodsFetched_1);
                podsActionCreator.getPods(KubeFactory_1.KubeFactory.getKubeService());
            }
            _this.state = {
                pod: props.pod,
                podStatusProps: props.podStatusProps,
                statusTooltip: props.statusTooltip,
                selectedTab: selectedPivot,
                selectedImageDetails: undefined,
                showImageDetails: function (imageId) {
                    var showImageDetails = function (imageDetails) {
                        _this.setState({
                            selectedImageDetails: imageDetails
                        });
                    };
                    ActionsCreatorManager_1.ActionsCreatorManager.GetActionCreator(ImageDetailsActionsCreator_1.ImageDetailsActionsCreator).getImageDetails(imageId, showImageDetails);
                }
            };
            return _this;
        }
        PodsRightPanel.prototype.render = function () {
            if (this.state.selectedImageDetails) {
                return React.createElement(ImageDetails_1.ImageDetails, { imageDetails: this.state.selectedImageDetails, onBackButtonClick: this._hideImageDetails });
            }
            return this._showPodDetails();
        };
        PodsRightPanel.prototype._showPodDetails = function () {
            return (this.state.pod ? (React.createElement(Page_1.Page, { className: "pods-right-panel-container pod-overview-full-size flex flex-grow" },
                this._getHeader(),
                React.createElement(Tabs_1.TabBar, { className: "pods-right-tab-bar", selectedTabId: this.state.selectedTab || "pod-details" /* PodsDetailsKey */, onSelectedTabChanged: this._onSelectedTabChanged, tabSize: "tall" /* Tall */ },
                    React.createElement(Tabs_1.Tab, { name: Resources.OverviewText, id: "pod-details" /* PodsDetailsKey */ }),
                    React.createElement(Tabs_1.Tab, { name: Resources.LogsText, id: "pod-logs" /* PodsLogsKey */ }),
                    React.createElement(Tabs_1.Tab, { name: Resources.YamlText, id: "pod-yaml" /* PodsYamlKey */ })),
                React.createElement("div", { className: "pod-details-right-content pod-overview-full-size page-content page-content-top" }, this._getPageContent())))
                : React.createElement(Spinner_1.Spinner, { className: "flex-grow flex-center", label: Resources.LoadingText }));
        };
        PodsRightPanel.prototype._getHeader = function () {
            return (React.createElement(PageTopHeader_1.PageTopHeader, { title: (this.state.pod.metadata && this.state.pod.metadata.name) || "", statusProps: this.state.podStatusProps, statusTooltip: this.state.statusTooltip, className: "pod-right-panel-header" }));
        };
        PodsRightPanel.prototype._getPageContent = function () {
            if (this.state.pod) {
                var _a = Utils_1.Utils.generatePodStatusProps(this.state.pod.status), statusProps = _a.statusProps, tooltip = _a.tooltip;
                var podErrorMessage = statusProps !== Status_1.Statuses.Success ? tooltip : "";
                var mainContentClass = this._getMainContentClassName(!!podErrorMessage);
                return (React.createElement(React.Fragment, null,
                    podErrorMessage && React.createElement(MessageCard_1.MessageCard, { severity: "Error" /* Error */ }, podErrorMessage),
                    React.createElement("div", { className: Util_1.css(podErrorMessage ? "page-content-top" : "", mainContentClass) }, this._getSelectedTabContent())));
            }
        };
        PodsRightPanel.prototype._getSelectedTabContent = function () {
            if (this.state.pod) {
                var componentProps = { key: this.state.pod.metadata.uid, pod: this.state.pod };
                switch (this.state.selectedTab) {
                    case "pod-logs" /* PodsLogsKey */:
                        return React.createElement(PodLog_1.PodLog, __assign({}, componentProps, { markTTICallback: this.props.markTTICallback }));
                    case "pod-yaml" /* PodsYamlKey */:
                        return React.createElement(PodYaml_1.PodYaml, __assign({}, componentProps, { markTTICallback: this.props.markTTICallback }));
                    default:
                        // For OrphanPod, the imageDetails view show/hide state is controlled via Right panel itself,
                        // unlike other PodDetails views where the parent controls the show/hide of image details
                        var imageDetails = this.props.showImageDetails || this.state.showImageDetails;
                        return React.createElement(PodOverview_1.PodOverview, __assign({}, componentProps, { showImageDetails: imageDetails, markTTICallback: this.props.markTTICallback }));
                }
            }
        };
        PodsRightPanel.prototype._getMainContentClassName = function (hasMessageCard) {
            // required to adjust the card size based on error message card in the pod overview.
            if (this.state.selectedTab === "pod-details" /* PodsDetailsKey */) {
                return "";
            }
            return Util_1.css("full-size", hasMessageCard ? "pod-overview-error-height" : "pod-overview-content-full-size");
        };
        return PodsRightPanel;
    }(React.Component));
    exports.PodsRightPanel = PodsRightPanel;
});
